import { useTranslation } from 'react-i18next';
import type {
  FlatfinderData,
  FlatfinderEstate,
  FlatfinderEstateInput,
} from 'realitiq-utils/src/flatfinder';
import { Modal } from '@/components/modals/new/modal';
import { Button } from '@/components/ui/button';
import { FlatfinderEstateForm } from './estate-form';

export function FlatfinderEstateModal({
  busy,
  data,
  estate,
  form,
  onDismiss,
  onSave,
  onTogglePublication,
}: {
  busy: boolean;
  data: FlatfinderData;
  estate?: FlatfinderEstate;
  form: 'new' | string | null;
  onDismiss: () => void;
  onSave: (estate: FlatfinderEstateInput) => void;
  onTogglePublication: (estate: FlatfinderEstate) => void;
}) {
  const { t } = useTranslation();
  if (!form) return null;

  return (
    <Modal
      isOpen
      open={() => {}}
      dismiss={onDismiss}
      dismissDisabled={busy}
      dismissOnOutsideClick={false}
      title={form === 'new' ? t('createApartment') : t('flatfinderWorkspaceEditApartment')}
      className="flex h-[90dvh] max-h-[48rem] max-w-2xl flex-col overflow-hidden rounded-lg border border-primary-light/20 shadow-lg"
    >
      <Modal.Body className="flex min-h-0 flex-1 flex-col overflow-hidden">
        {estate ? (
          <div className="mb-4 flex shrink-0 items-center justify-between gap-3 border-b px-1 pb-4">
            <span className="text-sm text-text-secondary">
              {estate.status === 'published' ? t('published') : t('unpublished')}
            </span>
            <Button
              type="button"
              disabled={busy || !estate.canPublish}
              onClick={() => onTogglePublication(estate)}
              variant="outline"
            >
              {estate.status === 'published' ? t('unpublish') : t('publish')}
            </Button>
          </div>
        ) : null}
        <FlatfinderEstateForm
          key={form}
          data={data}
          initial={estate}
          estateId={estate?.id ?? null}
          busy={busy}
          onSave={onSave}
          onCancel={onDismiss}
        />
      </Modal.Body>
    </Modal>
  );
}
